<template>
    <sy-resize-panel class="ellipsis-Text" @resize="handleResize">
        <div ref="displayDiv" class="display-div" @mouseenter="handleMouseenter($event)" @mouseleave="handleMouseleave">
            <slot>{{ text }}</slot>
        </div>
        <div ref="actualDiv" class="actual-div">
            <slot>{{ text }}</slot>
        </div>
    </sy-resize-panel>
</template>

<script>
export default {
    name: 'SyEllipsisText',
    props: {
        /**
         * 文本
         */
        text: {
            type: String,
            default: ''
        },
        /**
         * tooltip对象
         */
        tooltip: {
            type: Object,
            default: () => null
        },
        /**
         * 是否显示tooltip
         */
        showTooltip: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 显示宽度
            displayWidth: 0,
            // 实际宽度
            actualWidth: 0
        };
    },
    computed: {
        /**
         * 文本是否溢出
         */
        isOverflow() {
            return this.actualWidth > this.displayWidth;
        }
    },
    /**
     * 组件渲染完成方法
     */
    mounted() {
        this.computeSize();
    },
    /**
     * 组件更新方法
     */
    updated() {
        this.computeSize();
    },
    methods: {
        /**
         * 计算尺寸
         */
        computeSize() {
            if (!this.$refs.displayDiv || !this.$refs.actualDiv) {
                return;
            }

            const displayRect = this.$refs.displayDiv.getBoundingClientRect();
            this.displayWidth = displayRect.width;

            const actualRect = this.$refs.actualDiv.getBoundingClientRect();
            this.actualWidth = actualRect.width;
        },
        /**
         * 处理尺寸变化
         * @param rect
         */
        handleResize(rect) {
            this.computeSize();
        },
        /**
         * 鼠标进入事件
         * @params event
         */
        handleMouseenter(event) {
            if (!this.showTooltip || !this.tooltip || !this.isOverflow) {
                return;
            }

            this.tooltip.$refs.popper.innerText = this.$refs.actualDiv.innerText;
            // 修改tooltip参考对象
            this.tooltip.referenceElm = event.target;
            // 根据参考对象重新创建popper,更新popper位置
            this.tooltip.createPopper();
            this.tooltip.show();
        },
        /**
         * 鼠标离开事件
         */
        handleMouseleave() {
            if (!this.showTooltip || !this.tooltip || !this.isOverflow) {
                return;
            }

            this.tooltip.hide();
        }
    }
};
</script>

<style lang="scss" scoped>
.ellipsis-Text {
    position: relative;

    .display-div {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .actual-div {
        position: absolute;
        overflow: visible;
        white-space: nowrap;
        opacity: 0;
    }
}
</style>
